import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { SimpleFetch, SimpleFetchResponse } from '../../../_helpers';

const encodeImage = (img) => {
  let reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onloadend = () => {
      resolve(reader.result);
    }
  
    reader.readAsDataURL(img);
  })
}

class ModalComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      domain: JSON.parse(sessionStorage.getItem('selected_domain')).uuid,
      images: []
    }

    this.inputFile = React.createRef();
    this.previews = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancelSubmit = this.handleCancelSubmit.bind(this);
    this.handleImageRemoval = this.handleImageRemoval.bind(this);
  }

  handleChange(e) {
    let files = e.target.files;
    let images = [];
    
    [...files].map(image => images.push({image, name: image.name, preview: URL.createObjectURL(image)}));
    this.setState({images});
  }

  async handleSubmit(e) {
    e.preventDefault();

    let obj = {
      "images": []
    }

    const imageToBase = this.state.images.map(async img => {
      let base = await encodeImage(img.image);
      await obj.images.push(base);
    });

    Promise.all(imageToBase).then(async () => {
      let req = await SimpleFetch('POST', {}, obj, 'momentum', `gallery/upload/${this.state.domain}/domain`);
      let res = await SimpleFetchResponse(req, 'Ocorreu um erro a salvar sua imagem.', 'Mídia(s) salva(s) com sucesso!');

      if ( res ) {
        this.setState({images: []});
        this.props.handleModalDisplay();
        return this.props.handleReload();
      }
    });
  }

  handleCancelSubmit(e) {
    this.props.handleModalDisplay(e);
    this.setState({images: []});
  }

  handleImageRemoval(e) {
    let imageToRemove = e.target.getAttribute('data-image');
    let images = this.state.images;

    images.splice(imageToRemove, 1);

    this.setState({images});
  }

  render() {
    const { parentState, handleModalDisplay } = this.props;
    const { images } = this.state;
    
    return (
      <Modal
        className="modal"
        size="lg"
        centered
        show={(parentState.shouldShowModal === "true") ? true : false}
        onEnter={() => this.inputFile.current.click()}
        onHide={handleModalDisplay}
      >
        <Modal.Body>
          <form className="form-add-media" onSubmit={this.handleSubmit}>
            <label htmlFor="files" className="btn btn-blue">
              {
                images.length !== 0 ?
                  <>
                    <i className="linearicons-plus-circle"></i> Adicionar Mídias
                    <p className="media-count">{images.length} mídia(s) selecionada(s)</p>
                  </>
                : "Selecionar Mídias"
              }
            </label>
            <input name="files" id="files" type="file" multiple="multiple" accept="image/*" ref={this.inputFile} onChange={this.handleChange}/>

            {
              images.length !== 0 ?
                <>
                  <div className="previews">
                    <p className="description">Preview(s):</p>
                    {
                      images.map((img, index) => {
                        return <div className="previews-image" key={img.name} style={{backgroundImage: `url(${img.preview})`}}>
                          <a href="#" className="image-remove" onClick={this.handleImageRemoval} data-image={index}>
                            <i className="linearicons-trash2"></i>
                          </a>

                          <p className="image-size">
                            {
                              (Math.round(img.image.size / 1024) >= 1000 ?
                                `Aprox. ${Math.round((img.image.size / 1024) / 1000)} MB`
                              : `Aprox. ${Math.round(img.image.size / 1024)} KB`)
                            }
                          </p>
                        </div>
                      })
                    }
                  </div>

                  <button type="button" className="btn btn-red float-left" data-modal-display={false} onClick={this.handleCancelSubmit}>Cancelar</button>
                  <button type="submit" className="btn btn-blue float-right">Salvar</button>
                </>
              : null
            }
          </form>
        </Modal.Body>
      </Modal>
    )
  }
}

export default ModalComponent;